const HEADER_OFFSET = 76;

const PIXELS_PER_MS = 2.6;
const MIN_DURATION = 350;
const MAX_DURATION = 1400;

const easeInOutQuad = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

let frameId = null;

const animateScrollTo = (targetY) => {
  if (frameId !== null) cancelAnimationFrame(frameId);

  const startY = window.scrollY;
  const distance = targetY - startY;
  const duration = Math.min(
    Math.max(Math.abs(distance) / PIXELS_PER_MS, MIN_DURATION),
    MAX_DURATION
  );
  const startTime = performance.now();

  const step = (now) => {
    const t = Math.min((now - startTime) / duration, 1);
    window.scrollTo(0, startY + distance * easeInOutQuad(t));

    if (t < 1) {
      frameId = requestAnimationFrame(step);
    } else {
      frameId = null;
    }
  };

  frameId = requestAnimationFrame(step);
};

export const scrollToHash = (e, href) => {
  if (!href?.startsWith("#")) return;
  e.preventDefault();

  const id = href.slice(1);
  const target = id === "" || id === "home" ? null : document.getElementById(id);
  const targetY = target
    ? target.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET
    : 0;

  animateScrollTo(targetY);
};
